import React, { useEffect } from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		background: theme.palette.aeros.surface,
		flex: "none",
		gap: 12,
		borderBottom: `1px solid ${theme.mode === "light" ? theme.palette.divider : "rgba(255, 255, 255, 0.06)"}`,
		// Altura MINIMA, nao fixa: a linha de acoes (TicketActionButtonsCustom)
		// quebra em duas quando o painel e estreito, e com 64px fixos a segunda
		// linha ficava escondida sob o overflow hidden do card.
		minHeight: 64,
		padding: "8px 20px",
		[theme.breakpoints.down("sm")]: {
			flexWrap: "wrap",
		},
	},
	backButton: {
		minWidth: 32,
		padding: "6px 0 6px 6px",
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					className={classes.ticketHeader}
				>
					<Button color="primary" className={classes.backButton} onClick={handleBack}>
						<ArrowBackIos />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
